import { FC } from 'react';
import { Box } from '@mui/material';
import { LinkDeliveryMethod } from '../../services/sendLinkManager';
import { ESendLinkModal } from '../../constants';

interface FeedbackMessageProps {
  success: boolean;
  deliveryMethod: LinkDeliveryMethod;
  deliveryTarget: string;
}

export const DeliveryMethodFeedbackMessage: FC<FeedbackMessageProps> = ({
  success,
  deliveryMethod,
  deliveryTarget,
}) => {
  switch (deliveryMethod) {
    case LinkDeliveryMethod.Email:
    case LinkDeliveryMethod.Sms:
      return (
        <>
          {success
            ? ESendLinkModal.LinkSentMessage
            : ESendLinkModal.LinkFailedToSend}{' '}
          <Box component="span" fontWeight="bold">
            {deliveryTarget}.<br />
          </Box>
        </>
      );
    case LinkDeliveryMethod.QrCode:
      return !success ? <>{ESendLinkModal.QrCodeFailed}</> : null;
  }
};
